import { render, staticRenderFns } from "./Cassa.vue?vue&type=template&id=688b5e7c&"
import script from "./Cassa.vue?vue&type=script&lang=ts&"
export * from "./Cassa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports